<nav class="cl-nav-top">
  <div class="container">
    <div class="row">
      <div class="col-12 cl-grid-flex-centered">
        <label class="cl-nav-side-burger"  (click)="sidenav.toggle()">
          <i class="fas fa-fw fa-bars"></i>
        </label>
        @if (!(isSmall | async)) {
          <div class="cl-path" >
            @for (bc of  breadcrumbs; track bc.display) {
              <span>
                <a [routerLink]="bc.commands">{{ bc.display | orgResolver }}</a>
              </span>
            }
          </div>
        }
        @if ((isSmall | async)) {
          <div class="cl-path">
            @for (bc of  (breadcrumbs| slice:-2); track bc.display) {
              <span>
                <a [routerLink]="bc.commands">{{ bc.display | orgResolver }}</a>
              </span>
            }
          </div>
        }
        <div class="cl-logo cl-grid-flex-centered">
          <span>{{ env }}</span>
          <a href="https://castlabs.com/" target="_blank" rel="noopener"><i class="cl-asset-logo-eggshell"></i></a>
        </div>
      </div>
    </div>
  </div>
</nav>
